import React, { useState } from "react";
import "./Receipt.scss";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const Receipt = () => {
  const [loadingId, setLoadingId] = useState(null);

  const pauseCourse = async (id) => {
    setLoadingId(id);
    try {
      const login_user_id = localStorage.getItem("session_user_id");
      const login_action_type = localStorage.getItem("session_user_type");
      const login_school_id = localStorage.getItem("session_school_id");
      const login_user_status = localStorage.getItem("session_user_status");
      const url = `${process.env.REACT_APP_API_BASE_URL}/?login_action_type=${login_action_type}&status=${login_user_status}&login_user_id=${login_user_id}&f=studentPayemntPDF&school_id=${login_school_id}&duration=${id}`;

      const response = await axios.get(url, {
        responseType: "blob",
      });

      if (response.status === 200) {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = fileURL;
        link.setAttribute("download", `Last ${id} Quittung.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileURL);

        toast.success("Receipt downloaded successfully!");
      } else {
        toast.error("Failed to download receipt.");
      }
    } catch (error) {
      toast.error("An error occurred while downloading the receipt.");
      console.error(error);
    } finally {
      setLoadingId(null);
    }
  };


  const healthReceipt = async (action) => {
    if (loadingId !== null) return;
    const requestId = `health-${action}`;
    setLoadingId(requestId);
    try {
      const token = localStorage.getItem("session_user_login_cookie");
      if (!token || token === "null" || token === "undefined") {
        toast.error("Bitte melde dich erneut an, um deine Quittung abzurufen.");
        return;
      }
      const body = new URLSearchParams({
        login_user_id: localStorage.getItem("session_user_id") || "",
        login_action_type: localStorage.getItem("session_user_type") || "",
        school_id: localStorage.getItem("session_school_id") || "",
        login_cookie: token,
        action,
      });
      const url = new URL("student-health-receipt.php", process.env.REACT_APP_API_BASE_URL).href;
      const response = await axios.post(url, body, {
        responseType: action === "download" ? "blob" : "json",
        timeout: 60000,
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      if (action === "send") {
        if (response.data.status !== true) {
          throw new Error(response.data.message || "Der Versand konnte nicht bestätigt werden.");
        }
        toast.success(response.data.message);
        return;
      }
      const blob = response.data;
      if ((await blob.slice(0, 5).text()) !== "%PDF-") {
        let message = "Die Quittung konnte nicht erstellt werden.";
        try { message = JSON.parse(await blob.text()).message || message; } catch (_) {}
        throw new Error(message);
      }
      const fileURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = "Krankenkassenquittung-24-Monate.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(fileURL);
      toast.success("Deine Krankenkassenquittung wurde heruntergeladen.");
    } catch (error) {
      let message = error.message || "Die Quittung konnte nicht erstellt werden.";
      const data = error.response?.data;
      if (data instanceof Blob) {
        try { message = JSON.parse(await data.text()).message || message; } catch (_) {}
      } else if (data?.message) {
        message = data.message;
      } else if (error.code === "ECONNABORTED") {
        message = "Die Anfrage dauert zu lange. Bitte später erneut versuchen; einen Mailversand zuerst im Postfach prüfen.";
      }
      toast.error(message);
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div className="place_absence_section">
      <ToastContainer />
      <div className="container-fluid">
        <div className="user_detail">
          <div className="place_absence_title">
            <h2>Download Receipt</h2>
          </div>
        </div>
        <div className="place_absence">
          <div className="place_absence_inner">
            <div className="place_absence_cards row">
              <div className="place_absence_card col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="place_absence_card_inner">
                  <div className="place_absence_card_title">
                    <h2>Krankenkassenquittung</h2>
                  </div>
                  <p>Bezahlte Tanzkurse der letzten 24 Monate, einschliesslich abgelaufener Abos. Verrechnungen werden berücksichtigt.</p>
                  <div className="absent_btn mt-4 d-flex flex-wrap gap-3">
                    <button className="btn btn_primary" type="button"
                      onClick={() => healthReceipt("download")} disabled={loadingId !== null}>
                      {loadingId === "health-download" ? "Wird erstellt…" : "PDF herunterladen"}
                    </button>
                    <button className="btn btn_primary" type="button"
                      onClick={() => healthReceipt("send")} disabled={loadingId !== null}>
                      {loadingId === "health-send" ? "Wird gesendet…" : "Per E-Mail senden"}
                    </button>
                  </div>
                  <p className="mt-3">Der Versand erfolgt an deine hinterlegte E-Mail-Adresse.</p>
                </div>
              </div>

              <div className="place_absence_card col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="place_absence_card_inner">
                  <div className="place_absence_card_title">
                    <h2>Last Payment</h2>
                  </div>
                  <div className="absent_btn mt-5">
                    <button
                      className="btn btn_primary"
                      onClick={() => pauseCourse("1")}
                      disabled={loadingId === "1"}
                    >
                      {loadingId === "1" ? "Downloading..." : "Download"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="place_absence_card col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="place_absence_card_inner">
                  <div className="place_absence_card_title">
                    <h2>Last 3 Months Payment</h2>
                  </div>
                  <div className="absent_btn mt-5">
                    <button
                      className="btn btn_primary"
                      onClick={() => pauseCourse("3")}
                      disabled={loadingId === "3"}
                    >
                      {loadingId === "3" ? "Downloading..." : "Download"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="place_absence_card col-xxl-4 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="place_absence_card_inner">
                  <div className="place_absence_card_title">
                    <h2>Last 6 Months Payment</h2>
                  </div>
                  <div className="absent_btn mt-5">
                    <button
                      className="btn btn_primary"
                      onClick={() => pauseCourse("6")}
                      disabled={loadingId === "6"}
                    >
                      {loadingId === "6" ? "Downloading..." : "Download"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt;